const initial = {
    totalRequestsPerMonth: 0,
    requestsPerPlanPerMonth: [],
    filesPerPlanPerMonth: [],
    usersPerPlan: [],
    caps: [],
    totalMediaFiles: 0,
    filterYear: 2024,
    filterMonth: 0,
    usersRanking: [],
    isLoading: false,
};

export const CDNReducer = (state = initial, action) => {
    switch (action.type) {
        case "SAVE_RESULTS":
            return {
                ...state,
                totalRequestsPerMonth: action.payload.totalRequestsPerMonth,
                requestsPerPlanPerMonth: action.payload.requestsPerPlanPerMonth,
                filesPerPlanPerMonth: action.payload.filesPerPlanPerMonth,
                usersPerPlan: action.payload.usersPerPlan,
                caps: action.payload.caps,
                totalMediaFiles: action.payload.totalMediaFiles,
                filterYear: action.payload.filterYear,
                filterMonth: action.payload.filterMonth,
                usersRanking: action.payload.usersRanking
            }
        case "SET_lOADING":
            return {
                ...state,
                isLoading: action.payload
            }            
        default:
            return state;
    }
};